import React, { useState, useEffect } from "react";
import { Modal, FloatingLabel, Form } from "react-bootstrap";
import LoadingButton from "./LoadingButton.js";
import { useGlobalContext } from "./GlobalContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

function ModalLicencie({
  show,
  currentLicencieEdit,
  onHide,
  onValid,
  onCancel,
}) {
  const {
    db,
    user,
    getLicencie,
    getLicencies,
    handleShowAlert,
    handleShowConfirmation,
    handleCloseConfirmation,
    onShowModalSelection,
  } = useGlobalContext();
  const [displayName, setDisplayName] = useState(
    currentLicencieEdit ? currentLicencieEdit.displayName : ""
  );
  const [firstName, setFirstName] = useState(
    currentLicencieEdit ? currentLicencieEdit.firstName : ""
  );
  const [lastName, setLastName] = useState(
    currentLicencieEdit ? currentLicencieEdit.lastName : ""
  );
  const [email, setEmail] = useState(
    currentLicencieEdit ? currentLicencieEdit.email : ""
  );
  const [gender, setGender] = useState(
    currentLicencieEdit
      ? currentLicencieEdit.genderMale
        ? "male"
        : "female"
      : "male"
  );
  const [licenceNumber, setLicenceNumber] = useState(
    currentLicencieEdit ? currentLicencieEdit.licenceNumber : ""
  );
  const [keyPass, setKeyPass] = useState(
    currentLicencieEdit ? currentLicencieEdit.keyPass : false
  );
  const [lastLoginAt, setLastLoginAt] = useState(
    currentLicencieEdit ? currentLicencieEdit.lastLoginAt : null
  );

  useEffect(() => {
    if (show) {
      if (currentLicencieEdit) {
        setKeyPass(currentLicencieEdit.keyPass || false);
        setEmail(currentLicencieEdit.email || "");
        setDisplayName(currentLicencieEdit.displayName || "");
        setFirstName(currentLicencieEdit.firstName || "");
        setLastName(currentLicencieEdit.lastName || "");
        setLicenceNumber(currentLicencieEdit.licenceNumber || "");
        setGender(currentLicencieEdit.genderMale ? "male" : "female");
        setLastLoginAt(currentLicencieEdit.lastLoginAt);
      } else {
        setKeyPass(false);
        setEmail("");
        setDisplayName("");
        setFirstName("");
        setLastName("");
        setLicenceNumber("");
        setGender("male");
        setLastLoginAt(null);
      }
    }
  }, [currentLicencieEdit, show]);

  const onValidAjout = async () => {
    try {
      const newLicencie = await db.addLicencie({
        uid: "auto-generated" + Date.now(),
        displayName: displayName,
        firstName: firstName,
        lastName: lastName,
        licenceNumber: licenceNumber,
        genderMale: gender === "male",
        validated: true,
        lastLoginAt: null,
        "porte-feuille": 0
      });
      onValid(newLicencie);
    } catch (error) {
      console.log("Error add licencie", error);
    }
  };

  const handleUpdateLicencie = async () => {
    try {
      const updatedLicencie = await db.updateLicencie(currentLicencieEdit.uid, {
        displayName,
        licenceNumber,
        genderMale: gender === "male",
        firstName,
        lastName,
        keyPass
      });
      onValid(updatedLicencie);
    } catch (error) {
      console.log("Error edit licencie", error);
    }
  };

  const handleValidRemoveClub = async () => {
    await db.unsignalLicencie(currentLicencieEdit);
    onValid();
    handleCloseConfirmation();
  };

  const mergeWith = async (licencieSelected) => {
    await db.updateLicencie(currentLicencieEdit.uid, {
      displayName: licencieSelected.displayName,
      firstName: licencieSelected.firstName,
      lastName: licencieSelected.lastName,
      licenceNumber: licencieSelected.licenceNumber,
      simpleLevel: licencieSelected.simpleLevel,
      doubleLevel: licencieSelected.doubleLevel,
      mixteLevel: licencieSelected.mixteLevel,
      lastModifiedSynchro: licencieSelected.lastModifiedSynchro,
    });
    //modifier toutes les occurence de licencieSelectedUid dans les restes des données (entrainements, mouvements)
    await db.replaceInTrainings(licencieSelected.uid, currentLicencieEdit.uid);
    await db.removeLicencie(licencieSelected.uid);
    onValid();
    handleCloseConfirmation();
    handleShowAlert("Fusion réussie", "", "warning");
  };

  const onHandleMergeWith = async () => {
    const licencies = await getLicencies();

    onShowModalSelection(
      async (selectedLicencie) => {
        if (selectedLicencie.length === 0) return;
        const licencieSelectedUid = selectedLicencie[0];
        const licencieSelected = await getLicencie(licencieSelectedUid);
        handleShowConfirmation(
          "Fusion",
          "Etes vous sûr de vouloir fusionner " + currentLicencieEdit.displayName + " et " + licencieSelected.displayName + " ?",
          "success",
          "Fusionner",
          "Annuler",
          null,
          () => mergeWith(licencieSelected)
        )
      }

      , "Fusionner avec", [], () =>
      licencies.filter((l) => l.lastLoginAt === null)
    );
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {currentLicencieEdit
            ? "Modification d'un licencié"
            : "Ajout d'un licencié"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <FloatingLabel
            label="Adresse email"
            className="mb-3"
            style={{ width: "100%", display: "none" }}
          >
            <Form.Control
              type="email"
              style={{ width: "100%" }}
              autoComplete="on"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@example.com"
              disabled={true}
            />
          </FloatingLabel>
          <div
            className="mb-3"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Form.Check
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "10px",
              }}
              type="radio"
              id="male"
              label="Homme"
              value="male"
              name="gender"
              checked={gender === "male"}
              onChange={(e) => {
                setGender("male");
              }}
            />
            <Form.Check
              type="radio"
              label="Femme"
              id="female"
              name="gender"
              value="female"
              checked={gender === "female"}
              onChange={(e) => {
                setGender("female");
              }}
            />
          </div>

          <FloatingLabel
            label="Pseudo"
            className={displayName === "" ? "mb-3 required" : "mb-3"}
            style={{ width: "100%" }}
          >
            <Form.Control
              type="text"
              value={displayName}
              placeholder="john"
              onChange={(e) => setDisplayName(e.target.value)}
              required
            />
          </FloatingLabel>
          <FloatingLabel
            label="Prénom"
            className="mb-3"
            style={{ width: "100%" }}
          >
            <Form.Control
              type="text"
              value={firstName}
              placeholder="john"
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </FloatingLabel>
          <FloatingLabel label="Nom" className="mb-3" style={{ width: "100%" }}>
            <Form.Control
              type="text"
              value={lastName}
              placeholder="merandat"
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </FloatingLabel>
          <FloatingLabel
            label="Numéro de licence"
            className="mb-3"
            style={{ width: "100%" }}
          >
            <Form.Control
              type="text"
              placeholder="123456"
              value={licenceNumber}
              onChange={(e) => {
                setLicenceNumber(e.target.value);
              }}
            />
          </FloatingLabel>
          <Form.Check
            type="checkbox"
            id="keyPass"
            label="A les clefs d'accès"
            checked={keyPass}
            onChange={(e) => {
              setKeyPass(e.target.checked);
            }}
          />
        </Form>

      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {currentLicencieEdit ? (
              <LoadingButton
                className="btn btn-custom5"
                disabled={user.uid === currentLicencieEdit.uid}
                onClick={() => {
                  handleShowConfirmation(
                    "",
                    "Etes vous sur de vouloir retirer cette personne du club ?",
                    "danger",
                    "Retirer du club",
                    "Annuler",
                    handleValidRemoveClub
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ fontSize: "1em", marginRight: "5px", color: "red" }}
                />
                Retirer du club
              </LoadingButton>
            ) : null}
            {lastLoginAt ? (
              <LoadingButton className="btn btn-custom1" onClickPromise={onHandleMergeWith}>
                Fusionner avec
              </LoadingButton>
            ) : null}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <LoadingButton className="btn btn-custom1" onClick={onCancel}>
              Annuler
            </LoadingButton>
            <LoadingButton
              className="btn btn-custom2"
              onClickPromise={
                currentLicencieEdit ? handleUpdateLicencie : onValidAjout
              }
              disabled={displayName === ""}
            >
              {currentLicencieEdit ? "Enregistrer" : "Ajouter"}
            </LoadingButton>
          </div>
        </div>
      </Modal.Footer>
    </Modal >
  );
}

export default ModalLicencie;
